// extracted by mini-css-extract-plugin
module.exports = {"WrapperBadges":"Badges_WrapperBadges__Yit3t","Badge":"Badges_Badge__Y8Ahc","BadgeIcon":"Badges_BadgeIcon__hF_pE","WrapperContentTooltip":"Badges_WrapperContentTooltip___4GKl"};